import * as React from 'react';

import {
  DateTime,
} from 'luxon';

import {
  Lang,
} from '@bluecurrent/web-component-lib';

import handleCapitalize from '../../../../../../../../functions/handleCapitalize';

import Item from './Item';
import Divider from './Divider';

import handleItemHeightCalculation from '../../functions/handleItemHeightCalculation';
import handleItemValueCalculation from '../../functions/handleItemValueCalculation';

export default function Chart({
  data,
  type,
  isLoading,
}) {
  const { i18n } = Lang.useTranslation();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
      }}
    >
      {
        data.map((item, index) => {
          const nextDay = index >= 0 && index + 1 !== data.length ? data[index + 1].day : null;
          const previousHour = index > 0 ? data[index - 1].hour : null;
          const prices = data
            .filter((itm) => itm.amount !== undefined)
            .map((itm) => itm.amount);
          const hasNegative = prices.some((price) => price < 0);

          const { aboveZeroPercentage, belowZeroPercentage } = handleItemValueCalculation(prices);

          return item.type === 'divider'
            ? (
              <Divider
                key={item.id}
                weekday={
                  DateTime.fromFormat(nextDay, 'y-L-d').isValid
                    ? handleCapitalize(DateTime.fromFormat(nextDay, 'y-L-d').setLocale(i18n.language).toFormat('EEEE'))
                    : '--/--/--'
                }
                isSolid={previousHour === '23'}
                isLoading={isLoading}
              />
            ) : (
              <Item
                key={`${item.day}-${item.hour}`}
                amount={item.amount}
                hour={item.hour}
                day={item.day}
                index={index}
                height={
                  handleItemHeightCalculation(
                    prices,
                    item.amount,
                    type,
                  )
                }
                spacing={[
                  aboveZeroPercentage,
                  belowZeroPercentage,
                ]}
                type={type}
                hasNegative={hasNegative}
                isNow={DateTime.now().hour === Number(item.hour) && DateTime.fromFormat(item.day, 'y-L-d').hasSame(DateTime.now(), 'day')}
                isToday={DateTime.fromFormat(item.day, 'y-L-d').hasSame(DateTime.now(), 'day')}
              />
            );
        })
      }
    </div>
  );
}
